import { Route, Routes } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { ReferralsAccessLayout } from 'pages/settings/pages/referrals/layout/ReferralsAccessLayout'
import { ReferralsPageLayout } from 'pages/settings/pages/referrals/layout/ReferralsPageLayout'
import { ReferralsViewPage } from 'pages/settings/pages/referrals/pages'

export const ReferralsRouter = observer(() => {
  return (
    <Routes>
      <Route element={<ReferralsAccessLayout />}>
        <Route element={<ReferralsPageLayout />}>
          <Route path={'/'} element={<ReferralsViewPage />} />
        </Route>
      </Route>
    </Routes>
  )
})
